import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  openNotes$ = new Subject<void>();

  openNotes() {
    this.openNotes$.next();  // Emits event to subscribers
  }
}
